import { City } from './city';

export class State {
  value: string;
  label: string;
  cities: City[];

  constructor(value: string, label: string, cities: City[]) {
    this.value = value;
    this.label = label;
    this.cities = cities;
  }
}